export const whyCDGI = [
  {
    index: 0,
    value:
      "NAAC A+ Accredited: A mark of quality in teaching, research, and infrastructure.",
  },
  {
    index: 1,
    value:
      "Approved & Affiliated: AICTE-approved, RGPV & DAVV affiliated for technical and professional education.",
  },
  {
    index: 2,
    value:
      "Comprehensive UG & PG Courses: From B.Tech to MBA, B.Pharm to LLB, CDGI offers multidisciplinary programs for 360° growth.",
  },
  {
    index: 3,
    value:
      "Industry-Relevant Learning: Certified modules, live projects, internships, and expert mentorship prepare you for the real world.",
  },
  {
    index: 4,
    value:
      "100+ Placement Partners: With a record of top placements across IT, manufacturing, finance, and public sectors.",
  },
];

export const engineeringCourses = [
  {
    index: 0,
    name: "B.Tech in Computer Science Engineering (CSE)",
    link: "/Overview/66e7f7154e3cc865577c318f/computer-science-and-engineering",
  },
  {
    index: 1,
    name: "B.Tech in Information Technology (IT)",
    link: "/Overview/66e82451ccd836f84801f23a/information-technology",
  },
  {
    index: 2,
    name: "B.Tech in Electronics & Communication Engineering (ECE)",
    link: "/Overview/66e82a92ccd836f84801f2dd/department-of-electronics-and-communication",
  },
  {
    index: 3,
    name: "B.Tech in Mechanical Engineering",
    link: "/Overview/66e83053ccd836f84801f39c/department-of-mechanical-engineering",
  },
  {
    index: 4,
    name: "B.Tech in Civil Engineering",
    link: "/Overview/66e91028ccd836f84801f4a3/department-of-civil-engineering",
  },
  {
    index: 5,
    name: "B.Tech in Artificial Intelligence & Data Science",
    link: "/Overview/66e91cacccd836f84801f59a/artificial-intelligence-and-data-science",
  },
  {
    index: 6,
    name: "B.Tech in Computer Science & Information Technology",
    link: "/Overview/66e91fd6ccd836f84801f61c/computer-science-and-information-technology",
  },
  {
    index: 7,
    name: "Master of Computer Applications",
    link: "/Overview/67613e8460faee5f92ef2998/master-of-computer-application",
  },
];

export const mbaCourses = [
  {
    index: 0,
    name: "MBA (Master of Business Administration – General)",
    link: "/Overview/66e946e39fd5e8df87e79553/mba-full-time-2years",
  },
  {
    index: 1,
    name: "MBA in Marketing Management",
    link: "/Overview/66e950f99fd5e8df87e79620/mba-marketing-management-2years",
  },
  {
    index: 2,
    name: "MBA in Financial Administration",
    link: "/Overview/66e956629fd5e8df87e796f8/mba-financial-administration-2years",
  },
];

export const pharmacyUGCourses = [
  {
    index: 0,
    name: "B.Pharma (Bachelor of Pharmacy)",
    link: "/Overview/66e971de9fd5e8df87e79a8d/b-pharma",
  },
  {
    index: 1,
    name: "D.Pharma (Diploma in Pharmacy)",
    link: "/Overview/66e976d19fd5e8df87e79be1/d-pharma",
  },
];

export const pharmacyPGCourses = [
  {
    index: 0,
    name: "M.Pharma (Master of Pharmacy – Pharmaceutics)",
    link: "/Overview/66e97d209fd5e8df87e79d17/m-pharma",
  },
];

export const professionalCourses = [
  {
    index: 0,
    name: "BBA (General & Foreign Trade)",
    link: "/Overview/66eac4c9b7413a4074991fc2/bba",
  },
  {
    index: 1,
    name: "B.Com (Bachelor of Commerce)",
    link: "/Overview/66eac862b7413a4074992206/bcom",
  },
  {
    index: 2,
    name: "BCA (Bachelor of Computer Applications)",
    link: "/Overview/66eac83ab7413a4074992200/bca",
  },
  {
    index: 3,
    name: "MCA (Master of Computer Applications)",
    link: "/Overview/67613e8460faee5f92ef2998/master-of-computer-application",
  },
];

export const lawCourses = [
  {
    index: 0,
    name: "LLB (Hons)",
    link: "/Overview/66ec23f9382587071fb04adf/llb-hons-3-years",
  },
  {
    index: 1,
    name: "BA LLB (Hons)",
    link: "/Overview/66ec251a382587071fb04d44/ba-llb-hons-5-years",
  },
  {
    index: 2,
    name: "BBA LLB (Hons)",
    link: "/Overview/66ec254a382587071fb04d4a/bba-llb-hons-5-years",
  },
];

export const campusFacilities = [
  {
    index: 0,
    description: "Smart classrooms, R&D labs, startup incubation center",
  },
  {
    index: 1,
    description:
      "Library with 20,000+ resources, e-journals & digital archives",
  },
  {
    index: 2,
    description:
      "Hostel facilities for boys & girls with mess, security & Wi-Fi",
  },
  {
    index: 3,
    description: "Language lab, innovation club & mentorship programs",
  },
];

export const placementsAndIndustryIntegration = [
  {
    index: 0,
    description: "Pre-placement training, aptitude coaching, mock interviews",
  },
  {
    index: 1,
    description:
      "100+ recruiters including TCS, Infosys, Wipro, Capgemini, Cognizant",
  },
  {
    index: 2,
    description:
      "Career support for government jobs, entrepreneurship & higher education",
  },
];

export const cdgiFAQs = [
  {
    index: 0,
    question: "Is CDGI the best engineering colleges in Madhya Pradesh?",
    answer:
      "Yes. CDGI is NAAC A+ accredited, AICTE approved, and consistently ranked among the best private engineering colleges in Madhya Pradesh.",
  },
  {
    index: 1,
    question: "What UG & PG courses are offered at CDGI?",
    answer:
      "CDGI offers a wide variety of programs in Engineering, Pharmacy, Management, Law, Commerce, and Computer Applications.",
  },
  {
    index: 2,
    question: "Are there placement opportunities at CDGI?",
    answer:
      "Absolutely. CDGI provides 100% placement assistance and has a strong recruiter network with top MNCs and PSUs.",
  },
  {
    index: 3,
    question: "How can I apply for admission to CDGI?",
    answer:
      "Visit www.cdgi.edu.in to fill out the online application form or call our admissions helpline for counseling support.",
  },
];

